import y from "../../../../public/projects/embassy/projects/y.jpg";
import s from "../../../../public/projects/embassy/logo/s.png";
import evergreen from "../../../../public/projects/embassy/projects/ev.jpg"

// whitefield
import overviewImagewhitefield from "../../../../public/projects/embassy/whitefield/overview/1.webp";
import bannerDesktopImagewhitefield from "../../../../public/projects/embassy/whitefield/banner/1.webp";
import bannerMobileImagewhitefield from "../../../../public/projects/embassy/whitefield/banner/2.webp";
import Locationwhitefield from "../../../../public/projects/embassy/whitefield/location/1.webp";
import Hightlightswhitefield from "../../../../public/projects/embassy/whitefield/highlights/1.webp";
import floorplan1whitefield from "../../../../public/projects/embassy/whitefield/floorplan/1.webp";
import floorplan2whitefield from "../../../../public/projects/embassy/whitefield/floorplan/2.webp";
import floorplan3whitefield from "../../../../public/projects/embassy/whitefield/floorplan/3.webp";
import floorplan4whitefield from "../../../../public/projects/embassy/whitefield/floorplan/4.webp";
import floorplan5whitefield from "../../../../public/projects/embassy/whitefield/floorplan/5.webp";
import locationiconwhitefield from "../../../../public/projects/embassy/whitefield/overview/l.png";
import caliconwhitefield from "../../../../public/projects/embassy/whitefield/overview/c.png";
import newlaunchiconwhitefield from "../../../../public/projects/embassy/whitefield/overview/n.png";
import gallery1whitefield from "../../../../public/projects/embassy/whitefield/gallery/1.webp";
import gallery2whitefield from "../../../../public/projects/embassy/whitefield/gallery/2.webp";
import gallery3whitefield from "../../../../public/projects/embassy/whitefield/gallery/3.webp";
import gallery4whitefield from "../../../../public/projects/embassy/whitefield/gallery/4.webp";
import gallery5whitefield from "../../../../public/projects/embassy/whitefield/gallery/5.webp";


export const developerembassy = {
  properties: [
    {
      name: "Embassy Whitefield",
      image: bannerDesktopImagewhitefield,
      price: " On Request",
      state: " Bangalore",
      developer: "Embassy",
      location: "Whitefield, Bangalore",
      projectlocation: "Bangalore",
      bed: "2 - 3 BHK Apartments",
      size: "1186 - 1708 sq.ft.",
      url: `/embassy-whitefield`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Embassy Whitefield",
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};
export const Headers = {
  logo: s,
  data: {
    experience: "1993",
  },
  about: `Founded in 1993, Embassy Group is one of India's largest real estate conglomerates with a broad portfolio of over 85+ million sq. ft. of prime commercial, residential, retail, hospitality, services, and educational spaces across Delhi NCR, Bangalore, Chennai, Pune, Mumbai, Noida and Trivandrum in the Indian market and Serbia and Malaysia in the international market. Across all asset classes, Embassy places a strong emphasis on high standards of quality, delivery, world-class services, environmental management, and safety. Embassy sponsored India's first publicly traded REIT and Asia's largest REIT by area. As an extension of its vision to create world-class urban infrastructure, the company has also contributed in the field of education. The Group's Community Outreach programme empowers over 42,000 children across 143+ schools to create a positive social impact in India.`,
};



export const projectsembassy = {

  whitefield: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagewhitefield,
      bannerMobileImage: bannerMobileImagewhitefield,
      textOverlay: "",
      data: {
        title: "Embassy Whitefield",
        subtitle: "Whitefield, Bangalore",
        starting_price: "  On Request",
        payment_plan: "Under Construction",
        rerano: "Coming Soon",
        status: "New Launch",
      },
    },
    overview: {
      heading: "Embassy Whitefield in Bangalore",
      description: [
        "Whitefield. Spanning 3.75 acres, this development features approximately 393 thoughtfully designed apartments, offering 2, 2.5, and 3 BHK configurations to suit the diverse needs of modern homebuyers. The project is tailored for young professionals, families, and investors seeking a blend of luxury, comfort, and connectivity in Bangalore’s thriving IT hub. Embassy Whitefield’s prime location ensures seamless access to major business centers, educational institutions, hospitals, and shopping destinations, making daily life convenient and enjoyable. The proximity to the Metro Purple Line and major roadways enhances connectivity to the rest of the city, while the scenic views of Hoodi Lake and lush green surroundings create a serene living environment. Residents can enjoy a wide range of premium amenities such as a fully equipped clubhouse, swimming pool, fitness center, landscaped gardens, co-working spaces, outdoor sports courts, children’s play area, and 24/7 security, ensuring a holistic and secure lifestyle.",
        "The apartments are designed with modern architecture, ample natural light, and ventilation, providing expansive balconies and large windows for panoramic views. Embassy Whitefield’s launch is expected to cater to the increasing demand for high-quality residences in East Bangalore, especially among IT and ITeS professionals. With the trusted Embassy brand, meticulous planning, and a focus on luxury and sustainability, Embassy Whitefield emerges as a top choice for those looking to invest in a well-connected, future-ready home in Bangalore. The project’s competitive pricing and the promise of a vibrant community make it an attractive option for both end-users and investors seeking long-term value in one of the city’s most sought-after neighborhoods.",
      ],
      keywordLinks: {

      },
      image: overviewImagewhitefield,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconwhitefield,
          title: "On Request",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconwhitefield,
          title: "New Launch",
          subtitle: "Status",
        },
        {
          iconClass: newlaunchiconwhitefield,
          title: "Under Construction",
          subtitle: " Status",
        },
      ],
    },



    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "1186 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "2.5 BHK",
          area: "1451 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1708 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },

      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "1186 sq. ft.",
        price: "On Request",
        image: floorplan1whitefield,
      },
      {
        type: "2.5 BHK",
        area: "1451 sq. ft.",
        price: "On Request",
        image: floorplan2whitefield,
      },
      {
        type: "3 BHK",
        area: "1708 sq. ft.",
        price: "On Request",
        image: floorplan2whitefield,
      },


    ],

    highlights: {
      images: Hightlightswhitefield,
      tagline: "Highlights",
      features: [
        "The development spans across 3.7 acres.  ",
        "There are approximately 393 units available.  ",
        "Embassy Whitefield located in ITPL Main Road, Whitefield, Bangalore features a single tower comprising 22 stories.  ",
        "Embassy Whitefield in Bangalore Central provides excellent amenities including a Swimming Pool, Gym, and Clubhouse.  ",
        "KIADB Business Park is a well-known landmark in Whitefield, Bangalore.  ",

      ],
    },

    location: {
      image: Locationwhitefield,
      data: [
        {
          airport: {
            distance_time: "25 km",
            name: "Kempegowda International Airport",
          },
          school: {
            distance_time: "3.8 Km",
            name: "Vydehi School of Excellence",
          },
          railwayormetro: {
            distance_time: "- m",
            name: "Metro",
          },
          hospital: {
            distance_time: "3 Km",
            name: "Aster Whitefield Hospital  ",
          },
          mall: {
            distance_time: "2 Km",
            name: "Nexus Whitefield Mall    ",
          },
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1whitefield },
        { image: gallery2whitefield },
        { image: gallery3whitefield },
        { image: gallery4whitefield },
        { image: gallery5whitefield },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "",
      welcomeMessage:
        "Hi! I'm interested in  Embassy Whitefield, kindly share more details.",
    },

    faq: [
      {
        question: "Where is Embassy Whitefield located?",
        answer: "Embassy Whitefield is strategically situated in Whitefield, Bangalore.",
      },
      {
        question: "What types of apartments are available at Embassy Whitefield?",
        answer: "The project offers spacious 2 BHK, 2.5 BHK, and 3 BHK apartments.",
      },
      {
        question: "What are the key amenities offered at Embassy Whitefield?",
        answer: "Key amenities include a swimming pool, clubhouse, gymnasium, and landscaped gardens.",
      },
      {
        question: "Is Embassy Whitefield RERA approved?",
        answer: "Yes, Embassy Whitefield is RERA approved.",
      },
      {
        question: "Who is the developer of Embassy Whitefield?",
        answer: "Embassy Whitefield is developed by Embassy Group.",
      },
      {
        question: "How can I book an apartment in Embassy Whitefield?",
        answer: "You can book an apartment by contacting our sales team.",
      },
      {
        question: "What is the price range of apartments at Embassy Whitefield?",
        answer: "The price range for apartments at Embassy Whitefield is not disclosed yet.",
      },
      {
        question: "What makes Embassy Whitefield a good investment?",
        answer: "Its prime location in Whitefield, strong developer reputation, premium amenities, and proximity to IT hubs make Embassy Whitefield a promising investment for both end-users and investors.",
      },
      {
        question: "Is Embassy Whitefield close to tech parks and offices?",
        answer: "Yes, the project enjoys excellent connectivity to major IT parks like ITPL, EPIP Zone, and RMZ NXT.",
      },
      {
        question: "Are there good schools and hospitals near Embassy Whitefield?",
        answer: "Absolutely. Embassy Whitefield is surrounded by reputed educational institutions like Delhi Public School and hospitals like Manipal Hospital and Columbia Asia.",
      },
    ]
    ,

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },

};
